import React, { useState, useEffect } from 'react';
import { calculateTimeRemaining, formatTimeDisplay, getUrgencyLevel } from '../../../utils/timeUtils';

const CountdownTimer = ({ endDate, onExpired, className = "", showSeconds = true }) => {
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining(endDate));

  useEffect(() => {
    const timer = setInterval(() => {
      const newTime = calculateTimeRemaining(endDate);
      setTimeRemaining(newTime);
      
      if (newTime.expired && onExpired) {
        onExpired();
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate, onExpired]);

  if (timeRemaining.expired) {
    return (
      <span className={`text-red-500 font-bold ${className}`}>
        EXPIRED
      </span>
    );
  }

  const urgencyLevel = getUrgencyLevel(timeRemaining);
  const { days, hours, minutes, seconds } = timeRemaining;

  const getUrgencyStyles = () => {
    switch (urgencyLevel) {
      case 'critical':
        return 'text-red-600 animate-pulse';
      case 'urgent':
        return 'text-orange-600';
      case 'moderate':
        return 'text-yellow-600';
      default:
        return 'text-blue-600';
    }
  };

  return (
    <div className={`${getUrgencyStyles()} font-mono font-bold ${className}`}>
      {days > 0 && (
        <span className="bg-black/10 px-2 py-1 rounded mx-1">
          {days}d
        </span>
      )}
      <span className="bg-black/10 px-2 py-1 rounded mx-1">
        {hours.toString().padStart(2, '0')}h
      </span>
      <span className="bg-black/10 px-2 py-1 rounded mx-1">
        {minutes.toString().padStart(2, '0')}m
      </span>
      {showSeconds && (
        <span className="bg-black/10 px-2 py-1 rounded mx-1">
          {seconds.toString().padStart(2, '0')}s
        </span>
      )}
    </div>
  );
};

export default CountdownTimer;